import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WithdrawalPrepaidComponent } from './withdrawal-prepaid.component';
import { IonicModule } from '@ionic/angular';
import { ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';



@NgModule({
  declarations: [
    WithdrawalPrepaidComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule
  ]
})
export class WithdrawalPrepaidModule { }
